<div class="steps-bar">
  @for (step of activeScenario.scenarioSteps; track step; let i = $index) {
    <div class="steps-bar__item"
         [class.is-completed]="completedSteps.includes(step)"
         [class.is-current]="shouldUseVersionStatus(step)"
         [attr.data-test]="'stepBarItem'">
      @if (scenarioType === 'cpq') {
        @for (hStep of activeScenario.organizationSteps; track hStep; let i = $index) {
          @if (hStep === step) {
            <div class="steps-bar__hospital"
                 [class.first]="i === 0"
                 [class.last]="i === activeScenario.organizationSteps!.length - 1">
              @if (getTitlePosition() === i) {
                <div
                     class="steps-bar__hospital-title icon-home"
                     [class.steps-bar__hospital-even]="activeScenario.organizationSteps!.length%2 === 0">
                  {{ 'cpq-step-bar.organization-steps' | translate }}
                </div>
              }
            </div>
          }
        }
      } @else {
        @for (hStep of activeScenario.hospitalSteps; track hStep; let i = $index) {
          @if (hStep === step) {
            <div class="steps-bar__hospital"
                 [class.first]="i === 0"
                 [class.last]="i === activeScenario.hospitalSteps!.length - 1">
              @if (getTitlePosition() === i) {
                <div
                     class="steps-bar__hospital-title icon-home"
                     [class.steps-bar__hospital-even]="activeScenario.hospitalSteps!.length%2 === 0">
                  {{ 'orders-step-bar.hospital-steps' | translate }}
                </div>
              }
            </div>
          }
        }
      }
      @if (step === activeScenario.siemensStep) {
        <div class="steps-bar__siemens">{{ 'orders-step-bar.siemens-steps' | translate }}
        </div>
      }
      <div class="steps-bar__number {{step.includes('issue with the order') ? 'steps-bar__issue': ''}}"
           [attr.data-test]="'desc-stepBarNumber'">
        @if (completedSteps.includes(step) && step !== cpqOrderDeclinedStatus) {
          <span class="icon-check"></span>
        }
        @if (step.includes('issue with the order')) {
          <span class="icon-exclamationmark"></span>
        }
        @if (!completedSteps.includes(step) && !step.includes('issue with the order')) {
          <span>{{ i + 1 }}</span>
        }
      </div>
      <div class="steps-bar__title" [attr.data-test]="'desc-stepBarTitle'">
        {{ getTranslation(step, eTranslationTypes.LABEL) | translate }}
      </div>
      @if (currentDesc && currentStatus === step) {
        <div class="steps-bar__text">{{ currentDesc }}</div>
      }
      <div class="steps-bar__text" [attr.data-test]="'desc-stepBarText'">
        @if (comment && declinedStatues.includes(getStepName(step))) {
          {{ comment }}
        } @else {
          {{ getComment(step, eTranslationTypes.DESCRIPTION) | translate }}
        }
      </div>
    </div>
  }
</div>
